<div *ngIf="data.type == 'edit'" class="dialog-overlay">
    <div class="department-dialog">
        <div class="dialog-header">
            <h2 class="dialog-title">Edit Department Information</h2>
            <button type="button" class="close-btn" (click)="cancel()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
        <div class="dialog-content">
            <form [formGroup]="form" class="personalInfo">
                <div class="row">
                    <div class="col">
                        <div class="row">       
                            <label>Department ID</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="id" class="infofield" required
                                    placeholder="Department ID" disabled>
                                <div class="erroMessage"
                                    *ngIf="form.get('id')?.errors?.['required']">
                                    Department ID is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>Department Name</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="name" class="infofield" required
                                    placeholder="Department Name" disabled>
                                <div class="erroMessage"
                                    *ngIf="form.get('name')?.errors?.['required']">
                                    Department name is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <label>Head</label>
                            <div class="col-sm-12">
                                <div class="search-container">
                                    <ng-select class="custom" [items]="empList" bindLabel="name" formControlName="head"
                                        placeholder="Select Head" [searchable]="true" [multiple]="false">
                                    </ng-select>
                                </div>
                                <div class="erroMessage"
                                    *ngIf="form.get('head')?.errors?.['required']">
                                    Head is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>Abbreviation</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="abbr" class="infofield" placeholder="000">
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <label>Business</label>
                            <div class="col-sm-12">
                                <select formControlName="business" class="infofield" required>
                                    <option value="">Select Business</option>
                                    <option *ngFor="let obj of business " [value]="obj.id">{{obj.name}}</option>
                                </select>
                                <div class="erroMessage"
                                    *ngIf="form.get('business')?.errors?.['required']">
                                    Business is required.</div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <!-- Empty column for layout consistency -->
                    </div>
                </div>
            </form>
        </div>
        <div class="dialog-actions">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            <button 
                type="submit" 
                class="btn btn-primary" 
                [disabled]="!form.valid"
                (click)="onSubmit()">Save Changes</button>
        </div>
    </div>
</div>

<div *ngIf="data.type == 'create'" class="dialog-overlay">
    <div class="department-dialog">
        <div class="dialog-header">
            <h2 class="dialog-title">Add Department Information</h2>
            <button type="button" class="close-btn" (click)="cancel()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 6L6 18M6 6L18 18" stroke="#666" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
        <div class="dialog-content">
            <form [formGroup]="form" class="personalInfo">
                <div class="row">
                    <div class="col">
                        <div class="row">       
                            <label>Department Name</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="name" class="infofield" required
                                    placeholder="Department Name">
                                <div class="erroMessage"
                                    *ngIf="form.get('name')?.errors?.['required']">
                                    Department name is required.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>Head</label>
                            <div class="col-sm-12">
                                <div class="search-container">
                                    <ng-select class="custom" [items]="empList" bindLabel="name" formControlName="head"
                                        placeholder="Select Head" [searchable]="true" [multiple]="false">
                                    </ng-select>
                                </div>
                                <div class="erroMessage"
                                    *ngIf="form.get('head')?.errors?.['required']">
                                    Head is required.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="row">
                            <label>Abbreviation</label>
                            <div class="col-sm-12">
                                <input type="text" formControlName="abbr" class="infofield" placeholder="000">
                            </div>
                        </div>
                    </div>
                    <div class="col">
                        <div class="row">
                            <label>Business</label>
                            <div class="col-sm-12">
                                <select formControlName="business" class="infofield" required>
                                    <option value="">Select Business</option>
                                    <option *ngFor="let obj of business " [value]="obj.id">{{obj.name}}</option>
                                </select>
                                <div class="erroMessage"
                                    *ngIf="form.get('business')?.errors?.['required']">
                                    Business is required.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <div class="dialog-actions">
            <button type="button" class="btn btn-secondary" (click)="cancel()">Cancel</button>
            <button 
                type="submit" 
                class="btn btn-primary" 
                [disabled]="!form.valid"
                (click)="onSubmit()">Save Department</button>
        </div>
    </div>
</div>